import { render, staticRenderFns } from "./Part-Actions.vue?vue&type=template&id=99a0a816"
import script from "./Part-Actions.vue?vue&type=script&setup=true&lang=js"
export * from "./Part-Actions.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99a0a816')) {
      api.createRecord('99a0a816', component.options)
    } else {
      api.reload('99a0a816', component.options)
    }
    module.hot.accept("./Part-Actions.vue?vue&type=template&id=99a0a816", function () {
      api.rerender('99a0a816', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/tables/Part-Actions.vue"
export default component.exports